/**
 * @flow
 * @relayHash 178e899c7be318183c8128be1a4c6458
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type UserList_viewer$ref = any;
export type UserList_Refetch_QueryVariables = {|
  sortBy?: ?string,
  sortDirection?: ?string,
|};
export type UserList_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: UserList_viewer$ref
  |}
|};
export type UserList_Refetch_Query = {|
  variables: UserList_Refetch_QueryVariables,
  response: UserList_Refetch_QueryResponse,
|};
*/


/*
query UserList_Refetch_Query(
  $sortBy: String
  $sortDirection: String
) {
  viewer {
    ...UserList_viewer_40mLot
    id
  }
}

fragment UserList_viewer_40mLot on Viewer {
  usersPaginate(sortBy: $sortBy, sortDirection: $sortDirection) {
    users {
      ...UserListItem_user
      id
    }
  }
}

fragment UserListItem_user on User {
  id
  name
  email
  active
  canDelete
  blocked
  testText
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortDirection",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "UserList_Refetch_Query",
  "id": null,
  "text": "query UserList_Refetch_Query(\n  $sortBy: String\n  $sortDirection: String\n) {\n  viewer {\n    ...UserList_viewer_40mLot\n    id\n  }\n}\n\nfragment UserList_viewer_40mLot on Viewer {\n  usersPaginate(sortBy: $sortBy, sortDirection: $sortDirection) {\n    users {\n      ...UserListItem_user\n      id\n    }\n  }\n}\n\nfragment UserListItem_user on User {\n  id\n  name\n  email\n  active\n  canDelete\n  blocked\n  testText\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UserList_Refetch_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "UserList_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "sortBy",
                "variableName": "sortBy",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sortDirection",
                "variableName": "sortDirection",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UserList_Refetch_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "usersPaginate",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "sortBy",
                "variableName": "sortBy",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "sortDirection",
                "variableName": "sortDirection",
                "type": "String"
              }
            ],
            "concreteType": "UsersPagination",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "users",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "email",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "active",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canDelete",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "blocked",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "testText",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '79fee73d478e49901b617d0d5216404c';
module.exports = node;



// WEBPACK FOOTER //
// src/components/users/__generated__/UserList_Refetch_Query.graphql.js